<template>
  <v-menu
    ref="filter_menu"
    :attach="'#components'"
    :close-on-content-click="false"
    content-class="filters-menu"
    offset-y
    @input="changeFilterMenuState">
    <template #activator="{ on, value, attrs }">
      <sBadge
        color="red"
        data-qa="filter-block-badge"
        dot
        :offset-x="8"
        :offset-y="5"
        overlap
        :value="allFilters.used.length">
        <div v-on="on">
          <sButton
            v-bind="attrs"
            :class="[{'open': value}, 'filters-menu__btn px-2 py-1']"
            :color="value ? '#718e8c' : 'var(--black-color)'"
            data-qa="btn-open-filter"
            icon="filter"
            small
            type="text"/>
        </div>
      </sBadge>
    </template>
    <div
      class="filters-menu__list">
      <div
        v-if="!showFilters.length && !allFilters.notUsed.length"
        class="grey--text h6-text empty text-start pb-4">
        {{ $t('Tenders.filterListGenerated') }}
      </div>
      <div
        v-if="!showFilters.length"
        class="grey--text h6-text empty text-start pb-4">
        {{ $t('Planning.EpmtyFilters') }}
      </div>
      <div
        v-else
        :class="{'filters-template secondary__green_chosen rounded-lg px-3 pt-2 ': activeTemplateId}">
        <div
          v-if="activeTemplate.filterName"
          class="mb-2 h7-text-medium text-start"
          data-qa="filters-template-name">
          {{ activeTemplate.filterName }}
        </div>
        <div
          v-for="(filter, filterIndex) in showFilters"
          :key="`${filter.id}-${filterIndex}`"
          :data-qa="(activeTemplateId ? 'filters-template-': 'filter-') + filterIndex+(filter.new ? '-new' : '')">
          <FilterRow
            :key="`filter-row-${filter.id}-${filterIndex}`"
            class="pb-3"
            :elem="filter"
            :items="[filter, ...allFilters.notUsed].sort((a, b) => b.index - a.index)"
            :mode.sync="mode"
            :num="filterIndex"
            with-mode
            @cancel="deleteFilter(filter)"
            @change-contain-mode="(newVal, oldVal) => changeContainMode(newVal, oldVal)"
            @change-type="(newVal, oldVal) => changeType(newVal, oldVal)">
            <template #activator="{ disabled }">
              <slot
                :disabled="disabled"
                :item="filter"
                name="third_activator"/>
            </template>
          </FilterRow>
        </div>
      </div>

      <div class="flex mt-2 align-center">
        <sButton
          v-if="!showFilters.length || allFilters.notUsed.length"
          class="px-2"
          data-qa="btn-add-filter"
          :disabled="!allFilters.notUsed.length"
          icon="plus"
          icon-size="8px"
          small
          type="text"
          @click="addFilter">
          {{ $t('Common.Add').toUpperCase() }}
        </sButton>
        <div
          class="ml-auto">
          <v-menu
            content-class="menu"
            :disabled="!canSaveTemplate && !filters_templates.length"
            max-height="400px"
            offset-y
            right>
            <template #activator="{ on, value }">
              <div
                data-qa="open-menu"
                v-on="on">
                <sButton
                  class="px-2"
                  data-qa="btn-saved-filters"
                  :disabled="!canSaveTemplate && !filters_templates.length"
                  small
                  type="text">
                  {{ $t('Common.Filters.SavedFilters') }}
                  <sIcon
                    class="ml-2 my-auto"
                    :rotate="value ? '-180' : '0'"
                    size="10"
                    type="arrow"/>
                </sButton>
              </div>
            </template>
            <div
              :key="filters_templates.length"
              class="filter-list"
              data-qa="saved-filters-template-list"
              dense>
              <div
                v-for="(item) in filters_templates"
                :key="item.id"
                class="filter-list__item"
                :class="{'active-template': activeTemplateId == item.id}"
                :data-qa="'saved-filters-template-' + item.id"
                :value="item.id"
                @click="selectTemplate(item)">
                <div
                  class="filter-list__item-title"
                  data-qa="filters-template-name">
                  {{ item.filterName }}
                </div>
                <div
                  class="filter-list__item-action">
                  <FiltersTemplateDialog
                    :delete-filter-template="deleteTemplate"
                    :item="item">
                    <template #item="{ item: template, disabled }">
                      <slot
                        :disabled="disabled"
                        :item="template"
                        name="third_activator"/>
                    </template>
                  </FiltersTemplateDialog>
                </div>
              </div>
              <sDivider
                v-if="filters_templates.length && canSaveTemplate"
                class="ma-2"/>
              <FiltersTemplateDialog
                v-if="canSaveTemplate"
                :add-template="addTemplate"
                :filters="allFilters.used"
                :mode="mode">
                <template #item="{ item, disabled }">
                  <slot
                    :disabled="disabled"
                    :item="item"
                    name="third_activator"/>
                </template>
              </FiltersTemplateDialog>
            </div>
          </v-menu>
        </div>
      </div>
    </div>
  </v-menu>
</template>

<script>
import FilterRow from 'components/common/elements/FilterRow.vue'
import FiltersTemplateDialog from 'components/common/dialogs/FiltersTemplateDialog.vue'
import { debounce } from 'toolkit/utils/util'

import { filtersTemplatesMixin, storageMixin } from 'mixins'

import SmarttenderApi from '@/api/smarttenderApi'
const tender_api = new SmarttenderApi()

export default {
  name: 'FiltersBlockTenders',
  mixins: [ storageMixin, filtersTemplatesMixin ],
  data() {
    return {
      mode: true,
      activeTemplateId: null,
      isCategoryDialogOpen: false,
      allFilters: {
        used: [],   // Используемые фильтры
        new: [],    // новые фильтры (еще не переданные в поиск)
        notUsed: [] // свободные к использованию фильтры
      },
      spr: {
        category: [],
      },
    }
  },
  methods: {
    /**
     * При событии с наружи просто проставляем ключ активного фильтра
     */
    setActiveTemplateFilters(value) {
      this.activeTemplateId = value
    },
    onCategoryDialogOpen() {
      this.isCategoryDialogOpen = true
    },
    onCategoryDialogClose() {
      this.isCategoryDialogOpen = false
    },
    /**
     * Изменяем режим сравнения
     */
    changeContainMode(newVal, oldVal) {
      if (oldVal.new) {
        const indexFilter = this.allFilters.new.findIndex(i => i.id === oldVal.id)
        this.allFilters.new[indexFilter].contain = newVal
      } else {
        const indexFilter = this.allFilters.used.findIndex(i => i.id === oldVal.id)
        this.allFilters.used[indexFilter].contain = newVal

        this.$emit('applyFilters', {filters: this.allFilters.used, mode: this.mode })
      }
    },
    /**
     * Изменяем тип фильтра на другой
     */
    changeType(newVal, oldVal) {
      newVal.new = true
      if (oldVal.new) {
        const indexFilter = this.allFilters.new.findIndex(i => i.id === oldVal.id)
        this.$set(this.allFilters.new, indexFilter, newVal)
      } else {
        const indexFilter = this.allFilters.used.findIndex(i => i.id === oldVal.id)
        this.allFilters.new.push(newVal)
        this.allFilters.used.splice(indexFilter, 1)
      }
      oldVal.search = []
      delete oldVal.new
      this.allFilters.notUsed.push(oldVal)

      this.$emit('applyFilters', {filters: this.allFilters.used, mode: this.mode })
    },
    /**
     * Добавляем новый фильтр
     */
    addFilter() {
      let filter = this.$_.cloneDeep(this.allFilters.notUsed)
        .sort((a, b) => b.index - a.index)[0]

      let index = 0
      if (this.allFilters.used?.length) {
        index = this.allFilters.used[this.allFilters.used.length - 1].index + 1
      }

      this.allFilters.new.push({
        id: filter.id,
        title: filter.title,
        contain: true,
        search: [],
        new: true,
        index,
        type: filter.type,
      })
      const notUsedIndex = this.allFilters.notUsed.findIndex(i => i.id === filter.id)
      this.allFilters.notUsed.splice(notUsedIndex, 1)
    },
    /**
     * Удаляем фильтр
     */
    deleteFilter(filterItem) {
      const filterType = filterItem.new ? 'new' : 'used'
      let filter = this.$_.cloneDeep(this.allFilters[filterType])
      const indexFilter = filter.findIndex(i => i.id === filterItem.id)


      this.allFilters[filterType].splice(indexFilter, 1)
      delete filterItem.new

      filterItem.index = this.availableFilters.findIndex(i => i.id === filterItem.id)
      filterItem.search = []
      filterItem.contain = true
      this.allFilters.notUsed.push(filterItem)

      if (filterType !== 'new') {
        if (this.activeTemplateId) {
          this.$root.$emit('setActiveTemplateFilters', null)
        }
        this.$emit('applyFilters', {filters: this.allFilters.used, mode: this.mode })
      }
    },
    /**
     * Парсинг данных и заполнения данных
     */
    prepareDate: debounce(async function () {
      this.$set(this.allFilters, 'used', [])
      this.$set(this.allFilters, 'notUsed', [])

      if (this.activeTemplateId && !this.filters_templates.find(i => i.id === this.activeTemplateId)) {
        this.activeTemplateId = null
        this.$_savePropToDBStorage('tenders_template_filters', null)
      }

      if (this.activeTemplateId) {
        const filters = this.filters_templates
          .map(i => i.filterObject.filters)
          .flat(1) || []
        if (!filters?.length) {
          return
        }

        const classifications = filters
          .filter(i => i.type === 'categoryIds')
          .map(i => i.search).flat(1)

        const newItem = classifications?.length
          ? (classifications?.filter(
            newItem => !this.spr.category?.some(
              item => item.classificationCode === newItem.classificationCode
            )
          ) || [])
          : []

        const result = [...new Set([...this.spr.category, ...newItem])]

        this.$set(this.spr, 'category', result)
      } else {
        await this.$_getPropFromDBStorage('tenders_classification_filters', {})
          .then(async (classifications) => {
            const newItem = classifications?.length
              ? (classifications?.filter(
                newItem => !this.spr.category?.some(
                  item => item.classificationCode === newItem.classificationCode
                )
              ) || [])
              : []

            const result = [...new Set([...this.spr.category, ...newItem])]
            this.$set(this.spr, 'category', result)
          })
      }

      const used = []
      const notUsed = []
      if (this.filters && (this.filters?.tenderSearchParam?.containsFilter || this.filters?.tenderSearchParam?.notContainFilter)) {

        const allFilters = {}
        const setFilter = async (filters, contain) => {
          Object.entries(filters).forEach((filter) => {
            allFilters[filter[0]] = {
              value: this.$_.cloneDeep(filter[1]),
              contain
            }
          })
        }
        await setFilter(this.filters?.tenderSearchParam?.containsFilter || {}, true)
        await setFilter(this.filters?.tenderSearchParam?.notContainFilter || {}, false)

        const getSearch = async (value, type) => {
          if (!value) {
            return []
          }
          if (type === 'categoryIds') {
            const result = []
            value?.forEach((valueItem) => {
              let item = this.spr.category.find(i => i.classificationCode === valueItem)
              if (item) {
                result.push(item)
              } else {
                const item = {
                  classificationCode: valueItem,
                  id: null,
                  title: valueItem,
                }
                this.spr.category.push(item)
                result.push(item)
              }
            })
            return result
          }
          if (Array.isArray(value)) {
            return value
          }
          if (typeof value === 'object') {
            return Object.values(value)
          }
          return value
        }

        this.availableFilters.forEach(async (availableFilter) => {
          const filterItem = allFilters[availableFilter.type]
          if (filterItem) {
            used.push({
              id: availableFilter.id,
              title: availableFilter.title,
              index: availableFilter.index,
              contain: filterItem.contain,
              search: await getSearch(filterItem.value, availableFilter.type),
              type: availableFilter.type,
            })
            const newIndex = this.allFilters.new.findIndex(i => i.id === availableFilter.id)
            if (newIndex !== -1) {
              this.allFilters.new.splice(newIndex, 1)
            }
          } else {
            notUsed.push(availableFilter)
          }
        })

        this.$set(this.allFilters, 'used', used)
        this.$set(this.allFilters, 'notUsed', notUsed)
      } else {
        this.availableFilters.forEach((availableFilter, ) => {
          notUsed.push(availableFilter)
        })
      }

      this.allFilters.new.forEach((newFilter) => {
        const indexNewFilter = notUsed.findIndex(i => i.id === newFilter.id)
        notUsed.splice(indexNewFilter, 1)
      })

      this.$set(this.allFilters, 'used', used)
      this.$set(this.allFilters, 'notUsed', notUsed)

      const emptyClassifications = this.spr.category.filter(i => !i.id)
      if (emptyClassifications.length) {
        this.setCategorySpr(emptyClassifications)
      }
    }, 250),
    setCategorySpr(emptyClassifications) {
      if (!emptyClassifications?.length) {
        return
      }
      tender_api.subcategories(emptyClassifications.map(i => i.classificationCode))
        .then(classifications => {
          this.$sinfo('classifications', classifications)
          this.$set(this.spr, 'category', classifications?.map(i => ({
            id: i.id,
            title: i.title,
            classificationCode: i.classificationCode,
          })))
        })
    },
    /**
     * Выбор шаблона с фильтрами
     */
    selectTemplate(template) {
      this.$root.$emit('setTemplateFilters', template.filterObject)
      this.$root.$emit('setActiveTemplateFilters', template.id)
    },
    addTemplate(/*template*/) {
    },
    deleteTemplate() {
    },
    /**
     * Вызываем при изменении состояния меню фильтра
     */
    changeFilterMenuState: debounce(async function (val) {
      if (val) {
        await this.prepareDate()
      } else {
        this.$set(this.allFilters, 'new', [])
      }
    }, 250),
    /**
     * Метод для наблюдения
     */
    execWatch: debounce(async function (newValue, oldValue) {
      if (!oldValue || JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
        await this.prepareDate()
      }
    }, 250),
  },
  computed: {
    showFilters() {
      return [...this.allFilters.used, ...this.allFilters.new]
    },
    activeTemplate() {
      if (!this.activeTemplateId) {
        return {}
      }
      return this.filters_templates.find(i => i.id === this.activeTemplateId) || {}
    },
    /**
     * Доступно ли сохранение шаблона поиска
     */
    canSaveTemplate() {
      // Если есть активный шаблон или нет выбранных фильтров, то кнопка сохранения не активна
      if  (this.activeTemplate?.id || !this.allFilters?.used?.length) {
        return false
      }
      // проверяем что нет фильтров с пустыми параметрами
      return !this.allFilters.used.find(i => !i.search?.length)
    },
    filters_templates: {
      get() {
        if (this.filters_type) {
          let filters_templates = this.$store.getters.getFiltersTemplatesByType || {}
          return filters_templates[this.filters_type] || []
        }
        return []
      },
      set(val) {
        if ( this.filters_type ) {
          this.$store.commit('setFiltersTemplatesByType', val)
        }
      }
    },
  },
  watch: {
    mode(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('applyFilters', {filters: this.allFilters.used, mode: newValue })
      }
    }
  },
  props: {
    /**
     * доступні види фільтрів
     */
    availableFilters: {
      type: Array,
      default: () => []
    },
    /** Все фильтры */
    filters: {
      type: Object
    }
  },
  created() {
    ['filters.tenderSearchParam.notContainFilter', 'filters.tenderSearchParam.containsFilter']
      .forEach(prop => {
        this.$watch(prop, this.execWatch, { immediate: true, deep: true })
      })
  },
  async mounted() {
    await this.$store.dispatch('getFiltersTemplatesByType', this.filters_type )
    this.$root.$on('setActiveTemplateFilters', this.setActiveTemplateFilters)
    this.$root.$on('categoryDialog:open', this.onCategoryDialogOpen)
    this.$root.$on('categoryDialog:close', this.onCategoryDialogClose)
    this.$nextTick(() => {
      const menuVm = this.$refs.filter_menu
      if (menuVm) {
        const original = menuVm.closeConditional.bind(menuVm)
        menuVm.closeConditional = (e) => {
          if (this.isCategoryDialogOpen) { return false }
          return original(e)
        }
      }
    })
  },
  async beforeDestroy() {
    this.$root.$off('setActiveTemplateFilters', this.setActiveTemplateFilters)
    this.$root.$off('categoryDialog:open', this.onCategoryDialogOpen)
    this.$root.$off('categoryDialog:close', this.onCategoryDialogClose)
  },
  components: {
    FilterRow,
    FiltersTemplateDialog
  }
}
</script>
<style lang="scss" scoped>
.active-template {
  background-color: var(--v-secondary__green_chosen-base) ;
}
.filters-menu {
  &__badge-chip {
    height: 20px !important;
  }
  &__list {
    padding: 24px;
    background-color: var(--v-main__light_green-base);
    border: 2px solid var(--white-color);
  }
}
.empty {
  width: 350px;
}
.filters-group  {
  border-radius: 8px;
  overflow: auto;
}
.filter-list {
  background: var(--v-main__light_green-base);
  color: var(--black-color);
  display: block;
  padding: 8px 0;
  position: static;
  font-weight: 500;
  border-color: var(--white-color);
  &__item {
    $item: &;
    cursor: pointer;
    padding: 0 16px;
    flex: 1 1 100%;
    min-height: 35px;
    align-items: center;
    display: flex;
    &-title {
      text-align: start;
      font-size: 13px;
    }
    &-action {
      display: none;
      position: absolute;
      right: 5px;
      background: var(--v-main__light_green-base);
    }
    &:hover,
    &:focus {
      #{$item}-action {
        display: block;
      }
    }

    &.active-template {
      #{$item}-action {
        background: var(--v-secondary__green_chosen-base);
      }
    }
  }
}
</style>
<style lang="scss">
.filters-menu__badge {
  margin: auto 6px auto 0;
  & .s-badge__badge {
    height: 20px;
    padding: 0;
    z-index: 2;
  }
}
</style>
